export { IconSettingsProvider } from './IconSettings';
export {
  appearanceTypes,
  type IconAppearance,
  IconAppearanceProvider,
  useIconAppearance,
} from './raster/components/IconAppearanceProvider/IconAppearanceProvider';
export { makeRasterIcon } from './raster/components/RasterIcon/RasterIcon';
export { type SvgIconProps, SvgIconRoot } from './SvgIconRoot';
export { SvgIconRootV2 } from './SvgIconRootV2';
